// store/counter.js
import {defineStore} from 'pinia'
export const useCounterStore = defineStore('counter', {
    state: () => {
        return {
            title: '汇九川主平台',
            userInfo: {},
            menus:[],
            parkList:[]
        }
    },
    mutations: {},
    actions: {},
})
